// extracted by mini-css-extract-plugin
export default {"root":"InviteUserForm_root__sIfWz","form":"InviteUserForm_form__phc-w","after":"InviteUserForm_after__9rGld","avatarIcon":"InviteUserForm_avatarIcon__Eml-T"};